import { ApiLibsFn, DomainLibsFn } from '@digital-supply-chain/module';

const ApiLibs = ApiLibsFn(process.env.NODE_ENV);
const DomainLibs = DomainLibsFn(process.env.NODE_ENV);

const isDev = !!(process.env.NODE_ENV === 'development');

export let ApiService = {
  EngineerApi: ApiLibs.EngineerApi,
  ZPChainApi: ApiLibs.ZPChainApi,
  JrzzApi: ApiLibs.JrzzApi60,
  JrzzApi4: ApiLibs.JrzzApi40,
  JrzzApi80: ApiLibs.JrzzApi80,
  Api81: isDev ? '/api81' : ApiLibs.Api81,
  OssHost: ApiLibs.JnOssHost,
  OssLook: isDev ? "/prodimg_host" : ApiLibs.JnOssLook,
  OssHzHost: isDev ? (location.origin + "/hzmdstatic") : ApiLibs.HzOssHost,
  ImgHost: ApiLibs.JrzzApi60,
  ImageHost: isDev ? "/image_host" : ApiLibs.JnImageHost,
  Img2: ApiLibs.JnImageHost,
  StdApi: isDev ? (location.origin + '/std_api') : ApiLibs.StdApi,
};

export let DomainService = {
  Web: DomainLibs.EngineerWeb,
  ZPChainWorkerWeb: DomainLibs.ZPChainWorkerWeb,
  EngineerCommon: DomainLibs.EngineerCommon,
  ImWeb: DomainLibs.ImWeb,
  BlogWeb: DomainLibs.LectoWeb,
  LectoWeb: DomainLibs.LectoWeb,
  PublicPath: '/',
};

(window as any).DomainService = DomainService;